import { observable } from "mobx";

export class Article {
    @observable VAT: number;
    @observable acquisitionPrice: number;
    @observable productCatalogId: string;
    @observable productCategoryId: string;
    @observable code: string;
    @observable id: string;
    @observable productMaxOrderQuantity: number;
    @observable unitOfMeasurement: string;
    @observable productMinOrderQuantity: number;
    @observable name: string;
    @observable note: string;
    @observable productSortOrderInList: number;
    //@observable productTransportPackageSize: number;
    @observable productOfferedAmount: number;
    @observable productOfferedDeliveryDate: number;
    @observable productOrderedAmount: number;
    @observable customSalesPrice: string;
    @observable copyCustomSalesPrice: string;
    @observable stepDown: number;
    @observable stepUp: number;
    @observable isReadOnly: boolean;

    constructor() {
        this.VAT = 0;
        this.acquisitionPrice = 0;
        this.productCatalogId = "";
        this.productCategoryId = "";
        this.code = "";
        this.id = "";
        this.productMaxOrderQuantity = 0;
        this.unitOfMeasurement = "";
        this.productMinOrderQuantity = 0;
        this.name = "";
        this.note = "";
        this.productSortOrderInList = 0;
        //this.productTransportPackageSize = 0;
        this.productOfferedAmount = 0;
        this.productOfferedDeliveryDate = 0;
        this.productOrderedAmount = 0;
        this.customSalesPrice = "";
        this.copyCustomSalesPrice = "";
        this.stepDown = 0;
        this.stepUp = 0;
        this.isReadOnly = true;
    }
}